import { render, staticRenderFns } from "./TenantSubmissionDocuments.vue?vue&type=template&id=8b3c47e0&scoped=true&"
import script from "./TenantSubmissionDocuments.vue?vue&type=script&lang=js&"
export * from "./TenantSubmissionDocuments.vue?vue&type=script&lang=js&"
import style0 from "styles/tenants/submission-docs.scss?vue&type=style&index=0&id=8b3c47e0&lang=scss&scoped=true&"
import style1 from "./TenantSubmissionDocuments.vue?vue&type=style&index=1&id=8b3c47e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b3c47e0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8b3c47e0')) {
      api.createRecord('8b3c47e0', component.options)
    } else {
      api.reload('8b3c47e0', component.options)
    }
    module.hot.accept("./TenantSubmissionDocuments.vue?vue&type=template&id=8b3c47e0&scoped=true&", function () {
      api.rerender('8b3c47e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tenantProjects/submissions/TenantSubmissionDocuments.vue"
export default component.exports